import { getAddressList, doAjaxSetDefAddress, doAjaxRemoveAddress, doAjaxSaveAddress} from "@/assets/request/AddressRequest";
import { Message, MessageBox } from 'element-ui';
import {showLoading,hideLoading} from '@/js/loading.js';
export default {
    state:{
        list:[],
        globalEditAddress:{
            show:false,
            id:null,
            refreshAfterDone: false
        },
        receiveAddressId:null,
    },
    mutations:{
        upddateReceiveAddressIdMutation(state,id){
            state.receiveAddressId = id
        },
        updateList(state,{arr=[]}){
            if(!arr && toString.call(arr)!=='[object Array]') return console.log(arr);
            state.list = arr;
        },
        editGlobalEditAddressShow(state,{show,id, refreshAfterDone}){
            state.globalEditAddress.show = show;
            state.globalEditAddress.id=id;
            state.globalEditAddress.refreshAfterDone = refreshAfterDone
        },
    },
    actions:{
        async getAddress({commit}){
            showLoading();
            const address = await getAddressList().catch(r=>{
                hideLoading();
                const message = '获取地址异常';
                Message.error(message);
                console.trace({ message, r });
            });
            hideLoading();
            if(!address) return Message.warning('获取地址错误');
            commit('updateList',{arr:address.data.data.map(i=>{
                if(Boolean(Number(i.is_default))) commit('upddateReceiveAddressIdMutation',i.id)
                return {
                    ...i,
                    is_default:Boolean(Number(i.is_default))
                  }
            })})
        },
        async saveAddress({state,commit,dispatch},{province,provinceName,city,cityName,county,detailAddress,lxr,phone,defaultAddress,id=null,telephone,email,addressId}){
            showLoading();
            const data = {province,provinceName,city,cityName,county,detailAddress,lxr,phone,defaultAddress,telephone,email,addressId};
            id?data['id']=id:0;
            const saveRequest = await doAjaxSaveAddress(data).catch(r=>{
                hideLoading();
                Message.error('新增地址异常');
                console.trace({
                  message:'新增地址异常',
                  r
                });
            });
            hideLoading();
            if(!saveRequest) return;
            const r = saveRequest.data;
            const bool = Number(r) || (toString.call(r)==='[object Object]' && r.isFirst);
            Message[bool?'success':'error'](bool?'成功':'失败');
            if(bool){
                dispatch('getAddress');
                if(state.globalEditAddress.refreshAfterDone){
                    const findResult = this.state.editableTabs.find(i=>i.name===this.state.activeTab)
                    if(findResult){
                        this.commit('changeTab',{
                            componentName: this.state.activeTab,
                            query:findResult.query,
                            refresh:true
                        })
                    }
                }
                commit('editGlobalEditAddressShow',{show:false,id:null, refreshAfterDone: false});
                commit('upddateReceiveAddressIdMutation',r.returnAddress.id)
                //判断是否刷新页面
            }
        },
        async removeAddress({dispatch},{id}){
            const isDeleteModal = await MessageBox.confirm('确认删除吗？','删除',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(r=>{
                console.log(r);
            });
            if(!isDeleteModal || isDeleteModal==='cancel') return;
            showLoading();
            const deleteRequest = await doAjaxRemoveAddress(id).catch(r=>{
                hideLoading();
                Message.error('删除收货人地址异常');
                console.trace({
                  message:'删除收货人地址异常',
                  r
                });
            });
            hideLoading();
            if(deleteRequest.status!==200) return Message.warning('删除失败，请重试');
            let type = 'error';
            let message = '删除失败';
            if(Number(deleteRequest.data)===1){
                type='success';
                message='删除成功';
                dispatch('getAddress');
            }
            Message({
              type,
              message,
              showClose:true
            });
        },
        async setDefaultAddress({commit,dispatch},{id}){
            showLoading();
            const ajax = await doAjaxSetDefAddress(id).catch(r=>{
                hideLoading();
                Message.error('修改默认异常');
                console.trace({
                  message:'修改默认异常',
                  r
                });
            });
            hideLoading();
            Message[ajax.data.id==id?'success':'warning'](ajax.data.id==id?'成功':'失败');
            dispatch('getAddress');
        },
    },
    getters:{
        getAddressModal:s=>s.globalEditAddress,
        getAddressList: (state)=>{
            return state.list;
        },
        getAddressId:s=>({receiveAddressId:s.receiveAddressId})
    },
}